import React from 'react';
import { connect } from 'react-redux';

import submitForm from '../../../../utils/submitForm';
import Spin from '../../../../components/loading';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';
import Comment from '../../../comments/Comment';
import Sort from './Sort';
import Filter from './Filter';
import * as commentsActions from '../../../../redux/comments/actions';

import styles from '../details.scss';
import '../details.scss';

class UserComments extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNumber: 1,
      selectedSortFiled: {
        label: locales('fields.createdAt'), 
        value: 'createdAt'
      },
      sortDirection: 'desc',
      sortBy: 'createdAt',
      cafeName: '',
      errorText: locales('errors.default'),
      errorFlag: false,
      pageSize: 10
    };
    this.props.actions.initUserCommentsList();
    this.refreshList();
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  sortTable = () => {
    this.setState({ sortDirection: this.state.sortDirection == 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortDirection}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  setSortDirection = sortDirection => {
    this.setState({ sortDirection });
  };

  onChangeSortBy = selectedListItem => {
    this.setState({ 
      selectedSortFiled: selectedListItem, 
      sortBy: selectedListItem.value 
    });
  };

  onChangeCafeName = e => {
    const cafeName = e.target.value;
    this.setState({ cafeName });
  };

  loadNextPageData = () => {
    this.setState({ pageNumber: this.state.pageNumber + 1 }, () => {
      this.refreshList();
    });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    
    if (sort && filter) {
      query = `${filter}&${sort}`;
    } else if (filter) {
      query = `${filter}`;
    } else if (sort) {
      query = `${sort}`;
    }

    this.setState({ query, pageNumber: 1 }, () => {
      this.refreshList();
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event);
    this.setState({ filter: queryString }, () => this.filterAndSort());
  };

  clearForm = () => {
    this.setState({ filter: '', cafeName: '' }, () => {
      this.refreshList();
    });
  };

  refreshList = () => {
    const searchQuery = this.buildSearchQuery(this.state.pageNumber, this.state.pageSize);
    this.props.actions.fetchAllUserComments(this.props.userId, searchQuery);
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    let query = `pageNumber=${pageNumber}`;
    query += `&pageSize=${pageSize}`;
    query += `&sort=${this.state.sortBy}-${this.state.sortDirection}`;

    if (this.state.filter) {
      query += `&` + this.state.filter;
    }

    return query;
  };

  onSort = e => {
    e.preventDefault();

    this.setState(() => ({ pageNumber: 1 }), () => {
      this.refreshList();
    });
  };

  render() {
    let { 
      loading, 
      message, 
      failed, 
      error, 
      commentsList, 
      updateCommentStatusLoading,
      updateCommentStatusError,
      updateCommentStatusFailed,
      changeCafeAccessToResponseLoading,
      changeCafeAccessToResponseError,
      changeCafeAccessToResponseFailed
    } = this.props;

    let { totalRecords } = this.props;
    let { pageNumber, pageSize } = this.state;

    return (
      <Spin spinning={loading || updateCommentStatusLoading || changeCafeAccessToResponseLoading}>
        {this.state.errorFlag && this.handleAlert()}

        <section className="p-1 col-12">
          
          <main className="panel panel-default">
            {error || updateCommentStatusError || changeCafeAccessToResponseError ? (
              <div className="alert alert-danger">{locales('messages.server.error')}</div>
            ) : (
              <>
                {failed && <div className="alert alert-danger">{message}</div>}
                {updateCommentStatusFailed && <div className="alert alert-danger">{updateCommentStatusMessage}</div>}
                {changeCafeAccessToResponseFailed && <div className="alert alert-danger">{changeCafeAccessToResponseMessage}</div>}

                <div className="panel-heading">
                  <i className="fas fa-list-alt px-1" />
                  {locales('titles.transformedComments')}
                </div>
                <div className="panel-body">
                  <Filter 
                    cafeName={this.state.cafeName}
                    onChangeCafeName={this.onChangeCafeName}
                    applyFilters={this.applyFilters}
                    clearForm={this.clearForm}
                  />
                  
                  <Sort
                    selectedSortFiled={this.state.selectedSortFiled}
                    sortDirection={this.state.sortDirection}
                    sortBy={this.state.sortBy}
                    setSortDirection={this.setSortDirection}
                    onChangeSortBy={this.onChangeSortBy}
                    onSort={this.onSort}
                  />

                  {commentsList.map(comment => (
                    <Comment 
                      key={'cmnt_' + comment.id}
                      comment={comment}

                      updateCommentStatus={this.props.actions.updateCommentStatus}
                      changeCafeAccessStatusToResponse={this.props.actions.changeCafeAccessStatusToResponse}
                      // handleStarClick={this.handleStarClick}
                      // refreshList={this.refreshList}
                      // replyToComment={this.replyToComment}
                      // scrollToComment={this.scrollToComment}
                    />
                  ))}

                  {pageNumber * pageSize < totalRecords && (
                    <footer className="col-12 d-flex justify-content-center py-2">
                      <button onClick={this.loadNextPageData} className="btn btn-success w-75">
                        {locales('titles.loadMore')}
                      </button>
                    </footer>
                  )}
                </div>
              </>
            )}
          </main>
          
        </section>
      </Spin>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.commentsReducer.getAllUserCommentsLoading,
    failed: state.commentsReducer.getAllUserCommentsFailed,
    error: state.commentsReducer.getAllUserCommentsError,
    message: state.commentsReducer.getAllUserCommentsMessage,
    commentsList: state.commentsReducer.userCommentsList,
    totalRecords: state.commentsReducer.userCommentsTotalRecords,

    updateCommentStatusLoading: state.commentsReducer.updateCommentStatusLoading,
    updateCommentStatusFailed: state.commentsReducer.updateCommentStatusFailed,
    updateCommentStatusError: state.commentsReducer.updateCommentStatusError,
    updateCommentStatusMessage: state.commentsReducer.updateCommentStatusMessage,

    changeCafeAccessToResponseLoading: state.commentsReducer.changeCafeAccessToResponseLoading,
    changeCafeAccessToResponseFailed: state.commentsReducer.changeCafeAccessToResponseFailed,
    changeCafeAccessToResponseError: state.commentsReducer.changeCafeAccessToResponseError,
    changeCafeAccessToResponseMessage: state.commentsReducer.changeCafeAccessToResponseMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      initUserCommentsList: () => dispatch(commentsActions.initUserCommentsList()),

      fetchAllUserComments: (userId, query) => dispatch(commentsActions.fetchAllUserComments(userId, query)),

      changeCafeAccessStatusToResponse: (id, access) =>
        dispatch(commentsActions.changeCafeAccessStatusToResponse(id, access)),
      
      updateCommentStatus: (id, status) => dispatch(commentsActions.updateCommentStatus(id, status))
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserComments);
